export default __webpack_public_path__ + "static/media/screen4.e3a215c2.png";